/**
 * Created by richard on 7/14/14.
 */
var voucherOrderModel = angular.module('voucherOrderModel', ['schoolModel']);
voucherOrderModel.factory('VoucherOrderModelFactory', function(ApplicationService, RestService, authServiceFactory, SchoolModelFactory, AbstractModelService){
    var VoucherOrderModel = function(){
        this.endpoint = "/VoucherOrder";
        this.primaryKey = "schoolID";
    }
    VoucherOrderModel.prototype = new SchoolModelFactory();
    VoucherOrderModel.prototype.parent = SchoolModelFactory.prototype;
    VoucherOrderModel.prototype.new = function()
    {
        var schoolID = this.getSchoolID();
        var voucher = {schoolID: schoolID, CustName: '', CustEmail: '', CustCity: '', CustState: '', CustZip: '', CustCountry: '', OrderNum: '',
                        ResponseCode: '', ResponseText: '', Date: 'NOW()', Price: '', Batched: '', Last4: ''};
        return (this.data.push(voucher)) - 1;
    }

    return VoucherOrderModel;
});


voucherOrderModel.service('VoucherOrderModelService', function(VoucherOrderModelFactory){
    var voucherOrderModel = new VoucherOrderModelFactory();
    return voucherOrderModel;
});


